import { useEffect, useState } from 'react'
import type { ConnectionIntent, OutreachPreference } from '../../shared/pairvelle'
import {
  CONNECTION_INTENT_LABEL,
  CONNECTION_INTENT_OPTIONS,
  LIFESTYLE_TAG_SUGGESTIONS,
  OUTREACH_LABEL,
  OUTREACH_OPTIONS,
} from '../../shared/pairvelle'

export {
  CONNECTION_INTENT_LABEL,
  CONNECTION_INTENT_OPTIONS,
  LIFESTYLE_TAG_SUGGESTIONS,
  OUTREACH_LABEL,
  OUTREACH_OPTIONS,
  outreachFromDynamic,
  dynamicFromOutreach,
  defaultShowOutreach,
  showOutreachFromLegacy,
  type ConnectionIntent,
  type OutreachPreference,
  type AccountStandingSnapshot,
} from '../../shared/pairvelle'

export {
  GENDER_IDENTITY_OPTIONS,
  GENDER_INTEREST_OPTIONS,
  GENDER_IDENTITY_LABEL,
  parseInterestedIn,
  type GenderIdentity,
  type GenderInterest,
} from '../../shared/gender'

/** @deprecated Use OUTREACH_LABEL */
export const ROLE_LABEL = OUTREACH_LABEL
/** @deprecated */
export const ROLE_OPTIONS = OUTREACH_OPTIONS.map((o) => ({ ...o, icon: o.value === 'initiate' ? '→' : o.value === 'be_approached' ? '←' : '↔' }))

export function Logo({ compact, onClick }: { compact?: boolean; onClick?: () => void }) {
  const Tag = onClick ? 'button' : 'div'
  return (
    <Tag className={`logo ${compact ? 'logo-compact' : ''}`} aria-label="PairVelle home" onClick={onClick} type={onClick ? 'button' : undefined}>
      <span className="logo-mark"><i /><i /></span>
      <span>PairVelle</span>
    </Tag>
  )
}

export function OpenTestBanner({ compact }: { compact?: boolean }) {
  return (
    <div className={`open-test-banner${compact ? ' open-test-banner--compact' : ''}`}>
      <span className="open-test-label">PairVelle Open Test</span>
      <em className="open-test-tagline">Meet, flirt, follow, and monetize — free messaging when interest is mutual.</em>
    </div>
  )
}

export function placeholderGradient(base: string | null | undefined): string {
  const color = base && /^#[0-9a-fA-F]{6}$/.test(base) ? base : '#8ed9b7'
  return `linear-gradient(145deg, ${color}55 0%, ${color}22 45%, #f7f4e9 100%)`
}

export function Avatar({ name, color, photoUrl, size = 48, className }: { name: string; color?: string | null; photoUrl?: string | null; size?: number; className?: string }) {
  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt=""
        className={className}
        style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover', objectPosition: 'center' }}
        loading="lazy"
      />
    )
  }
  return (
    <div className={className ?? 'own-avatar'} style={{ width: size, height: size, fontSize: Math.max(14, Math.round(size * 0.38)), background: placeholderGradient(color) }} aria-hidden>
      {(name || '?').slice(0, 1).toUpperCase()}
    </div>
  )
}

export function useHashRoute(): [string, (r: string) => void] {
  const [route, setRoute] = useState(() => window.location.hash.replace(/^#/, '') || '/')
  useEffect(() => {
    const handler = () => setRoute(window.location.hash.replace(/^#/, '') || '/')
    window.addEventListener('hashchange', handler)
    return () => window.removeEventListener('hashchange', handler)
  }, [])
  return [route, (r: string) => { window.location.hash = r }]
}

export function NavIcon({ name }: { name: 'discover' | 'favorites' | 'messages' | 'profile' }) {
  const icons = {
    discover: (<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8" /><path d="m15.2 8.8-2.1 4.3-4.3 2.1 2.1-4.3 4.3-2.1Z" /></svg>),
    favorites: (<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.5 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z" /></svg>),
    messages: (<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v8Z" /></svg>),
    profile: (<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></svg>),
  }
  return icons[name]
}

export function intentLabel(intent: ConnectionIntent): string {
  return CONNECTION_INTENT_LABEL[intent]
}

export function outreachLabel(outreach: OutreachPreference): string {
  return OUTREACH_LABEL[outreach]
}
